<template>
  <div class="about container">
    <h1>About</h1>
    <p>Infinite newsfeed of trending repositories from HackerNews, Reddit and Github 📰</p>
    <p>GitNews was originally a mobile app has been built with Nativescript VueJS for learning purpose <a href="https://learn.uno">(Learning Lab Challenge)</a>.<br>
    I then quickly built a webapp to make it accessible to anyone using the power of VueJS!</p>
    <br>
    <ul>
      <li><a href="https://learn.uno" target="_blank">⚗️ Learning Lab</a></li>
      <li><a v-on:click="openContact()">💡 Ask for a feature</a></li>
      <li><a href="https://paypal.me/kanbanote" target="_blank">🎁 Donate</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'About',
  methods: {
    openContact () {
      const UserVoice = window.UserVoice || []
      UserVoice.push(['show'])
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  line-height: 1.5;
  min-height: 55vh;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  font-size: var(--font-lg);
  margin-bottom: 16px;
}

a {
  cursor: pointer;
}
</style>
